const formatPriceUS = (priceStart?: number, priceEnd?: number) => {
  if (typeof priceStart !== 'number' && typeof priceEnd !== 'number') {
    return '-';
  }
  return `US$ ${priceStart}-${priceEnd}`;
};

export { formatPriceUS };
